/* global naja, $, intervalFunction */
class IframeInputExtension {
    selectors = {
        container: '.iframe-input-container',
        popup: '.iframe-input-popup',
        content: '.iframe-input-content',
        caption: '.iframe-input-caption',
        option: '.iframe-input-option',
        input: '.iframe-input',
        group: '.iframe-input-group',
        attributes: {
            caption: 'data-iframe-input-caption',
            value: 'data-iframe-input-value'
        },
        type: {
            select: '.iframe-input-type-select',
            input: '.iframe-input-type-input'
        }
    }

    // zabrání vícenásobnému navázání globálních handlerů
    _globalHandlersBound = false;

    initialize(naja) {
        window.addEventListener('DOMContentLoaded', this.init.bind(this));
        naja.addEventListener('complete', this.init.bind(this));
        naja.uiHandler.addEventListener('interaction', this.init.bind(this));
    }

    init() {
        this.addStyles();
        $(this.selectors.container).each((index, container) => {
            this.initIframeInput(container);
        });

        // globální "klik mimo" 
        if (!this._globalHandlersBound) {
            $(document).on('click.iframeInputsOutside', (event) => {
                if (!$(event.target).closest(this.selectors.container).length) {
                    this.closeAll();
                }
            });

            // zavřít vše při ESC kdekoliv na stránce
            $(document).on('keyup.iframeInputsEsc', (event) => {
                if (event.key === 'Escape') {
                    this.closeAll();
                }
            });

            this._globalHandlersBound = true;
        }
    }

    initIframeInput(container) {
        const $container = $(container);

        // iframe load → navážeme clicky uvnitř iframe documentu (např. na .iframe-input-option)
        $container.find(this.selectors.popup).off('.iframeInputs');
        $container.find(this.selectors.popup).on('load.iframeInputs', (event) => {
            this.registerPopupDocumentEvents(container, $(event.target).contents());
        });

        // klik na group (tlačítko/box) → toggle
        $container.find(this.selectors.group).off('.iframeInputs');
        $container.find(this.selectors.group).on('click.iframeInputs', (event) => {
            // nepropagovat až na document, ať se nespustí "klik mimo"
            event.stopPropagation();
            this.toggle($container);
        });

        // Enter/Esc v inputu → zavřít
        $container.find(this.selectors.input).off('.iframeInputs');
        $container.find(this.selectors.input).on('keyup.iframeInputs', (event) => {
            if (event.key === 'Enter' || event.key === 'Escape') {
                this.close($container);
            }
        });
    }

    registerPopupDocumentEvents(container, document) {
        const optionSelector = this.selectors.option;

        // click na možnost uvnitř iframe
        $(document).off('click.iframeInputsOptions', optionSelector);
        $(document).on('click.iframeInputsOptions', optionSelector, (event) => {
            const $target = $(event.target).closest(optionSelector);
            if ($target.length) {
                const caption = $target.attr(this.selectors.attributes.caption);
                let value = $target.attr(this.selectors.attributes.value);
                if (value === undefined) {
                    value = $target.find('td.col-number').text().trim();
                }
                this.optionClicked(container, caption, value);
            }
        });
    }

    optionClicked(container, caption, value) {
        return this.isSelect(container)
            ? this.onSelectOptionClicked(container, caption, value)
            : this.onInputOptionClicked(container, value);
    }

    onSelectOptionClicked(container, caption, value) {
        const $input = $(container).find(this.selectors.input);
        const $caption = $(container).find(this.selectors.caption);
        $input.val(value);
        $caption.html(caption);
        this.close(container);
        $input.trigger('change');
    }

    onInputOptionClicked(container, value) {
        const $input = $(container).find(this.selectors.input);
        $input.val(value);
        const provide = $input.data('provide');
        if (provide) {
            naja.makeRequest('POST', provide, { value: value }, { history: false })
                .then(response => {
                    if (response.note) {
                        $('#document-note').val(response.note);
                        $('#document-name').val(response.contactName);
                        $('#document-street').val(response.contactStreet);
                        $('#document-locality').val(response.contactLocality);
                        $('#document-postal').val(response.contactPostal);
                        $('#document-ico').val(response.contactIco);
                        $('#document-dic').val(response.contactDic);
                    }
                });
        }
        this.close(container);
        $input.trigger('change');
    }

    isSelect(container) {
        return $(container).find(this.selectors.type.select).length > 0;
    }

    isInput(container) {
        return $(container).find(this.selectors.type.input).length > 0;
    }

    getPosition(container) {
        const $input = $(container).find(this.selectors.group);
        if ($input.length === 0) {
            return 'iframe-input-popup--below';
        }
        const viewportHeight = $(window).height();
        const inputOffset = $(container).offset().top;
        const $popup = $(container).find(this.selectors.popup);
        return (inputOffset + $popup.height() > viewportHeight)
            ? 'iframe-input-popup--above'
            : 'iframe-input-popup--below';
    }

    isOpen(container) {
        return $(container).hasClass('iframe-input--open');
    }

    toggle(container) {
        if (this.isOpen(container)) {
            this.close(container);
        } else {
            this.open(container);
        }
    }

    open(container) {
        this.closeAllExcept(container);
        $(container).addClass('iframe-input--open');
        this.addStyles(container);
    }

    close(container) {
        $(container).removeClass('iframe-input--open');
        this.addStyles(container);
    }

    closeAll() {
        $(this.selectors.container).removeClass('iframe-input--open');
    }

    closeAllExcept(container) {
        $(this.selectors.container).not(container).removeClass('iframe-input--open');
    }

    addStyles(container) {
        const $content = $(container).find(this.selectors.content);
        const $popup = $(container).find(this.selectors.popup);
        const $input = $(container).find(this.selectors.group);

        const dropdownPosition = this.getPosition(container);
        $content.removeClass('iframe-input-popup--above iframe-input-popup--below');
        $content.addClass(dropdownPosition);

        $input.css('top', 0);
        if (this.isOpen(container) && dropdownPosition === 'iframe-input-popup--above') {
            $input.css('top', $popup.height());
        }
    }
}

export default IframeInputExtension;
